import { post } from 'api'

export const log = async values => {
  return post(`/ApplicationInsights/log`, values)
}
